{
  "agentStatus": {
    "failed": "funktioniert nicht",
    "not_installed": "nicht installiert",
    "not_logged_in": "nicht angemeldet",
    "ready": "bereit"
  },
  "connect": {
    "approve": "Diesen PC bestätigen",
    "approveNote": "Der Befehl öffnet DMW im Browser, um diesen PC zu bestätigen. Ohne Browser zeigt er einen Code: Geben Sie ihn hier ein.",
    "download": "DMW Connector herunterladen und installieren",
    "enterCode": "Den angezeigten Code eingeben",
    "installByCommand": "DMW Connector mit einem Befehl installieren",
    "open": "Ihn öffnen",
    "useCommand": "Stattdessen einen Befehl verwenden"
  },
  "device": {
    "keyFingerprint": "Schlüssel-Fingerabdruck",
    "label": "Computername",
    "platform": "System",
    "version": "Version des DMW Connectors"
  },
  "download": {
    "button": "DMW Connector {{version}} für {{system}} herunterladen ({{size}} MB)",
    "commandElsewhere": "Unter Linux oder macOS, dort in einem Terminal:",
    "commandNote": "Fügen Sie ihn in ein Terminal auf diesem PC ein (auf dem Mac: die App Terminal). Er installiert den DMW Connector nur für Sie, ohne Administratorrechte, und startet ihn bei jeder Anmeldung.",
    "connect": "DMW Connector öffnen",
    "copyCommand": "Befehl kopieren",
    "linuxNote": "Erlauben Sie nach dem Herunterladen, die Datei als Programm auszuführen.",
    "macNote": "Nicht von Apple signiert: macOS blockiert ihn beim ersten Mal. Öffnen Sie Systemeinstellungen › Datenschutz & Sicherheit und wählen Sie Trotzdem öffnen.",
    "none": "Dieser Server bietet noch kein Installationsprogramm an.",
    "noneAdministrator": "Legen Sie eine Version des DMW Connectors in seinen Release-Ordner (threads.connector_hub.release_folder).",
    "noneForSystem": "Für dieses System gibt es noch kein Installationsprogramm. Verwenden Sie stattdessen unten einen Befehl.",
    "noneMember": "Bitten Sie Ihre Administration, eines bereitzustellen.",
    "nothingOpened": "Nichts geöffnet? Installieren Sie zuerst den DMW Connector und versuchen Sie es dann erneut.",
    "otherSystems": "Andere Systeme:",
    "windowsNote": "Noch nicht signiert: Windows meldet „Der Computer wurde durch Windows geschützt“. Wählen Sie Weitere Informationen, dann Trotzdem ausführen. Er wird nur für Sie installiert, ohne Administratorrechte."
  },
  "list": {
    "connectAnother": "Weiteren PC verbinden",
    "details": "Details",
    "enterCode": "Code eingeben",
    "getConnector": "DMW Connector herunterladen",
    "hideDetails": "Details ausblenden",
    "intro": "Ihr PC führt die Agenten Ihrer Durchläufe aus, mit Ihren eigenen Konten.",
    "lastSeen": "Zuletzt gesehen {{when}}",
    "loadFailed": "Ihre PC-Liste konnte nicht geladen werden",
    "neverSeen": "Noch nicht verbunden",
    "noPc": "Mit Ihrem Konto ist noch kein PC verbunden.",
    "online": "Verbunden",
    "pairedAt": "Gekoppelt",
    "pcName": "PC-Name",
    "rename": "Umbenennen",
    "revoke": "Widerrufen",
    "revokeConfirm": "DMW Connector widerrufen",
    "revokeConfirmMessage": "„{{label}}“ widerrufen? Die Verbindung wird getrennt und kann nicht wieder aufgebaut werden. Das lässt sich nicht rückgängig machen; um den PC wieder zu nutzen, koppeln Sie ihn neu.",
    "revokeConfirmTitle": "„{{label}}“ widerrufen",
    "revoking": "Wird widerrufen …",
    "saveName": "Namen speichern",
    "startOn": "Starten Sie DMW Connector auf {{pc}} über das Startmenü.",
    "startService": "Starten Sie ihn auf {{pc}} mit systemctl --user start dmw-connector; dmw-connector status sagt dort, warum er nicht verbunden ist.",
    "thisPc": "Dieser PC",
    "title": "Diesen PC verbinden",
    "useComputerName": "Den Computernamen verwenden ({{name}})",
    "yourPcs": "Ihre PCs"
  },
  "models": {
    "contextSize": {
      "hint": "Der Agent selbst schätzt {{tokens}} Tokens. Diese Schätzung allein wird nicht verwendet.",
      "itemName": "Kontextgröße von {{model}}",
      "needsNumber": "Geben Sie eine ganze Zahl von Tokens über 0 ein.",
      "note": "Wo Sie es gelesen haben",
      "notePlaceholder": "Zum Beispiel: die Seite des Anbieters zu diesem LLM",
      "question": "Tragen Sie das vom LLM-Anbieter angegebene Kontextfenster ein.",
      "reviewNotice": "Kommt als Element für Fähigkeitskorrekturen in einen Änderungssatz. Kuratierende sehen es im Review durch wie jedes Element.",
      "title": "Kontextgröße von {{model}} ist unbekannt",
      "tokens": "Kontextgröße (Tokens)"
    }
  },
  "pairCommand": {
    "notConfigured": "Dieser Server hat keine Adresse für DMW Connectors eingestellt (threads.connector_hub.public_origin), daher können DMW Connectors noch nicht koppeln. Fragen Sie die Administration."
  },
  "pairing": {
    "account": "Ihr Konto",
    "accountValue": "{{displayName}} ({{email}})",
    "approve": "Kopplung bestätigen",
    "approvedMessage": "„{{label}}“ ist jetzt mit Ihrem Konto gekoppelt. Der DMW Connector bemerkt das bei seiner nächsten Abfrage von selbst; Sie können diese Seite schließen.",
    "approvedTitle": "DMW Connector gekoppelt",
    "approving": "Wird bestätigt …",
    "closed": {
      "approved": {
        "message": "Die Kopplung von „{{label}}“ wurde schon bestätigt. Wenn Sie das waren, steht der DMW Connector in Ihrer Liste der DMW Connectors.",
        "title": "Dieser Code wurde bereits bestätigt"
      },
      "denied": {
        "message": "Die Kopplung von „{{label}}“ wurde abgelehnt. Um diesen PC zu koppeln, starten Sie die Kopplung dort erneut.",
        "title": "Dieser Code wurde bereits abgelehnt"
      },
      "expired": {
        "message": "Codes gelten nur wenige Minuten. Um „{{label}}“ zu koppeln, starten Sie die Kopplung auf diesem PC erneut.",
        "title": "Dieser Code ist abgelaufen"
      }
    },
    "code": "Code",
    "codeHelp": "Acht Buchstaben. Groß- und Kleinschreibung und der Bindestrich spielen keine Rolle.",
    "codeInvalidCharacter": "„{{character}}“ kommt in Codes nie vor. Codes bestehen nur aus diesen Buchstaben: {{alphabet}}.",
    "codeLabel": "Code vom DMW Connector",
    "codeWrongLength": "Ein Code hat acht Buchstaben, dieser hat {{letterCount}}.",
    "deniedMessage": "Es wurde nichts gekoppelt. Der DMW Connector auf „{{label}}“ erfährt, dass die Kopplung abgelehnt wurde.",
    "deniedTitle": "Kopplung abgelehnt",
    "deny": "Ablehnen",
    "denying": "Wird abgelehnt …",
    "expiresAt": "Code gültig bis",
    "intro": "Ihr DMW Connector zeigt einen Code wie WDJB-MJHT. Geben Sie ihn hier ein, um zu sehen, welcher PC gekoppelt werden möchte, und bestätigen oder lehnen Sie ab.",
    "lookUp": "Anfrage anzeigen",
    "lookingUp": "Code wird nachgeschlagen …",
    "otherCode": "Anderen Code eingeben",
    "requestTitle": "Dieser PC möchte mit Ihrem Konto gekoppelt werden",
    "requestedAt": "Angefragt",
    "selfReported": "PC-Name, System und Version sind Angaben des DMW Connectors über sich selbst.",
    "server": "DMW-Server",
    "title": "PC verbinden: Code eingeben",
    "warningMessage": "Bestätigen Sie nur, wenn Sie den DMW Connector gerade selbst auf Ihrem PC gestartet haben und er den Code {{userCode}} zeigt. Wenn Ihnen jemand diesen Link oder Code geschickt hat, lehnen Sie ab: Eine Bestätigung ließe dessen PC unter Ihrem Konto arbeiten.",
    "warningTitle": "Bestätigen Sie nur eine Kopplung, die Sie selbst gestartet haben"
  },
  "pcPage": {
    "answers": {
      "noAnswer": "{{pc}} hat nicht geantwortet. Prüfen Sie, ob der DMW Connector dort läuft.",
      "noBrowser": "{{pc}} kann keinen Browser öffnen. Öffnen Sie dort den DMW Connector.",
      "noPage": "Auf {{pc}} ist die eigene Seite ausgeschaltet.",
      "offline": "{{pc}} ist offline gegangen. Starten Sie dort den DMW Connector.",
      "opened": "Auf {{pc}} geöffnet.",
      "signInOpen": "Auf {{pc}} ist schon eine Anmeldung offen. Schließen Sie sie dort im Browser ab.",
      "signInStarted": "Die Anmeldung ist auf {{pc}} geöffnet. Schließen Sie sie dort im Browser ab.",
      "tooSoon": "{{pc}} wurde eben schon gefragt: Schauen Sie dort nach, oder versuchen Sie es in ein paar Sekunden noch einmal.",
      "updateNeeded": "Aktualisieren Sie den DMW Connector auf {{pc}}, um seine Seite von hier zu öffnen."
    },
    "asking": "Frage {{pc}} …"
  },
  "providers": {
    "addKeyOn": "Schlüssel auf {{pc}} hinterlegen",
    "apiKey": "API-Schlüssel",
    "inTerminal": "In einem Terminal auf {{pcs}}:",
    "models_one": "{{count}} LLM",
    "models_other": "{{count}} LLMs",
    "none": "Noch kein PC hat seine Agenten gemeldet. Richten Sie Ihren PC ein, dann erscheinen sie hier.",
    "perPc": "Auf jedem PC",
    "setUpOn": "Auf {{pc}} einrichten",
    "signInOn": "Auf {{pc}} anmelden",
    "states": {
      "needs_key": "Schlüssel nötig",
      "needs_sign_in": "Anmeldung nötig",
      "not_installed": "Nicht installiert",
      "not_working": "Funktioniert nicht",
      "offline": "PC offline",
      "ready": "Bereit"
    },
    "title": "Agenten und API-Schlüssel"
  },
  "routes": {
    "agent": "Agent (ACP)",
    "apiKinds": {
      "anthropic": "Anthropic",
      "gemini": "Gemini",
      "openai": "OpenAI",
      "openai_compatible": "OpenAI-kompatibel"
    },
    "catalogueFailed": "Sein LLM-Katalog konnte nicht gelesen werden.",
    "catalogueLeftOut": "LLM-Katalog: {{reported}}; {{invalid}} ungültige und {{overBudget}} über der Grenze des Berichts ausgelassen.",
    "factCount_one": "{{count}} Angabe gemeldet",
    "factCount_other": "{{count}} Angaben gemeldet",
    "factsOmitted_one": "{{count}} Angabe dazu passte nicht in die Grenze des Berichts, die alle LLM-Routen dieses PCs teilen, und wurde ausgelassen; sie blockiert keine Turns.",
    "factsOmitted_other": "{{count}} Angaben dazu passten nicht in die Grenze des Berichts, die alle LLM-Routen dieses PCs teilen, und wurden ausgelassen; sie blockieren keine Turns.",
    "gta": "API-Routen laufen über GTA {{version}} ({{revision}}).",
    "gtaNotStarted": "GTA, über das die API-Routen laufen, ist noch nicht gestartet.",
    "kind": "Läuft über",
    "missingKey": "Schlüssel fehlt",
    "models": "LLMs",
    "noFacts": "noch keine",
    "none": "Keine eingerichtet",
    "providerStates": {
      "insufficient_credits": "kein Guthaben",
      "invalid_key": "Schlüssel abgelehnt",
      "ok": "bereit",
      "rate_limited": "Ratenlimit",
      "unavailable": "Anbieter nicht erreichbar"
    },
    "route": "LLM-Route",
    "skipped": "Turns überspringen diese LLM-Route und nehmen die nächste erlaubte LLM-Route des Durchlaufs.",
    "sources": "Fähigkeiten",
    "status": "Status",
    "title": "Agenten und API-Routen"
  },
  "setup": {
    "agents": {
      "needOne": "Sie brauchen mindestens einen Agenten oder API-Schlüssel, der bereit ist."
    },
    "button": {
      "cloudNeedsPermission": "Ohne DMW Connector auf Ihrem PC laufen Cloud-LLMs nur über die API-Schlüssel des Servers, und nur für die Gruppen, die ein Projekt in seinen Einstellungen nennt. Bitten Sie die Projektadministration, Sie aufzunehmen, oder verbinden Sie Ihren PC.",
      "label": "Diesen PC verbinden",
      "nothingRunsTitle": "Nichts von Ihnen ist verbunden"
    },
    "check": "Erneut prüfen",
    "continue": "Einrichtung fortsetzen",
    "done": {
      "body": "Ihr DMW Connector kann jetzt Durchläufe ausführen.",
      "connectors": "Ihre DMW Connectors",
      "startThread": "Durchlauf zu einem Dokument starten",
      "title": "Dieser PC ist bereit"
    },
    "followCurrent": "Zum aktuellen Schritt",
    "later": "Später erledigen",
    "pair": {"waiting": "Warte auf Ihren DMW Connector …"},
    "serverAddress": {
      "administrator": "Setzen Sie threads.connector_hub.public_origin auf die öffentliche Adresse dieses Servers und starten Sie den Server neu. DMW Connectors koppeln sich mit dieser Adresse.",
      "member": "Ihre Administration muss erst die Serveradresse festlegen."
    },
    "start": {
      "body": "Der DMW Connector auf {{pcs}} startet nach dem Koppeln von selbst und verbindet sich."
    },
    "status": {
      "current": "aktueller Schritt",
      "done": "erledigt",
      "not_applicable": "nicht nötig",
      "to_do": "offen",
      "waiting_for_administrator": "wartet auf Ihre Administration"
    },
    "steps": {
      "agents": "Agenten und API-Schlüssel",
      "done": "Fertig",
      "pair": "DMW Connector holen und koppeln",
      "server_address": "Serveradresse",
      "start": "Starten",
      "welcome": "Willkommen"
    },
    "stepsLabel": "Einrichtungsschritte",
    "title": "Diesen PC einrichten",
    "welcome": {
      "body": "Nutzen Sie Ihre eigenen Agenten-Abos und API-Schlüssel auf diesem PC.",
      "notNow": "Jetzt nicht, ich lese nur und mache Reviews",
      "start": "Diesen PC einrichten"
    }
  },
  "thisPc": {
    "iAmHere": "Ich bin hier",
    "noneOfThem": "An keinem davon",
    "notThisPc": "Nicht dieser PC",
    "otherPcs": "Andere PCs",
    "which": "An welchem PC sind Sie gerade?"
  }
}
